import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-money-lion',
  templateUrl: './money-lion.component.html',
  styleUrls: ['./money-lion.component.css']
})
export class MoneyLionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
